module.exports = __webpack_public_path__ + "static/img/thumb_1.020b502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_1.png
// module id = Lex5
// module chunks = 0